module.exports = __webpack_public_path__ + "img/equipo_16-9_960.b45f6f7c.webp";